function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512px",
    height: "512px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 511.5,103.5 C 511.5,108.5 511.5,113.5 511.5,118.5C 437.061,176.428 362.728,234.595 288.5,293C 268.697,306.582 248.697,306.916 228.5,294C 152.467,234.998 76.1336,176.498 -0.5,118.5C -0.5,113.5 -0.5,108.5 -0.5,103.5C 3.31887,89.5154 12.3189,80.682 26.5,77C 179.167,76.3333 331.833,76.3333 484.5,77C 498.681,80.682 507.681,89.5154 511.5,103.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M -0.5,145.5 C 47.4813,182.476 95.4813,219.476 143.5,256.5C 95.4797,301.522 47.4797,346.522 -0.5,391.5C -0.5,309.5 -0.5,227.5 -0.5,145.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 511.5,146.5 C 511.5,228.167 511.5,309.833 511.5,391.5C 464.665,346.832 418.332,301.665 372.5,256C 372.759,254.739 373.426,253.739 374.5,253C 420.042,217.285 465.709,181.785 511.5,146.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 353.5,269.5 C 404.465,318.63 455.298,367.964 506,417.5C 501.58,427.503 493.746,433.336 482.5,435C 331.167,435.667 179.833,435.667 28.5,435C 17.9267,433.216 9.92672,427.716 4.5,418.5C 56.2031,368.463 108.536,319.129 161.5,270.5C 181.642,285.475 201.642,300.641 221.5,316C 245.005,329.456 268.671,329.789 292.5,317C 313.264,301.63 333.598,285.797 353.5,269.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.4dc47a68ea282cabd031fe5ef11b89d7.svg";
export { ForwardRef as ReactComponent };